import { FAVOURITES_SET_LISTS } from '../ConstantsBrafab/constants';

const DEFAULT_STATE = {
    favouriteLists: [],
};

export const favourites = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case FAVOURITES_SET_LISTS:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}